import { useEffect } from 'react';
import { dataLayerPush } from '@/utils/gtm';
import {
    IOptimizelyFormEvent,
    IOptimizelyFormSubmittedGtmDataLayerObject,
} from '@/components/OptimizelyForm/OptimizelyForm.interface';

export const useOptimizelyFormsEvents = () => {
    useEffect(() => {
        if (typeof window.$$epiforms !== 'undefined') {
            window.$$epiforms(document).ready(function myfunction() {
                window.$$epiforms(".EPiServerForms").on("formsSubmitted",
                    function (event: IOptimizelyFormEvent) {

                        if (event.isSuccess) {
                            const gtmData: IOptimizelyFormSubmittedGtmDataLayerObject = {
                                event: 'navigate_form',
                                data: {
                                    form_id: event.workingFormInfo?.Id,
                                    form_name: event.workingFormInfo?.Name,
                                    form_stage: 'submit'
                                }
                            };

                            dataLayerPush(JSON.stringify(gtmData));
                        }
                    });
            });
        }
    });
};